@use "u";

@layer components {
    $anchor-name: --tab-bar-selected-tab;

    .tab-bar {
        display: flex;
        flex-direction: column;
        width: 100%;
        anchor-scope: $anchor-name;

        .tabs {
            margin-bottom: .75rem;
            display: flex;
            gap: .5rem;

            &.tabs-center {
                justify-content: center;
            }

            &.tabs-left {
                justify-content: left;
            }

            &.tabs-right {
                justify-content: right;
            }

            >.selected-tab {
                anchor-name: $anchor-name;
            }

            >.marker {
                transition-property: left, right;
                transition-duration: 500ms;
                position-anchor: $anchor-name;
                pointer-events: none;
                border-bottom: 2px solid var(--color-fg-500);
                position: fixed;
                inset: anchor(top) anchor(right) anchor(bottom) anchor(left);

                @starting-style {
                    inset: anchor(top) anchor(right) anchor(bottom) anchor(left);
                }
            }
        }

        .content {
            height: 100%;
            overflow: clip;
        }
    }
}